import LooseItemListTable from './looseItemListTable.container';

export default LooseItemListTable